import { GraphQL } from '@guestgoodie/graphql'

import { FormData } from './hooks/useUploadButtonRow'
import { FormTranslations } from '../translations'

export type NewButtonRow = FormData

export type DirtyButtonRow = Omit<
  GraphQL.ButtonRowFragmentFragment,
  'translations' | 'items'
> & {
  isDirty: true
  translations: FormTranslations
  items: (Omit<GraphQL.ButtonRowItemFragmentFragment, 'translations'> & {
    translations: FormTranslations
  })[]
}

export type ButtonRow =
  | NewButtonRow
  | GraphQL.ButtonRowFragmentFragment
  | DirtyButtonRow

export function isNewButtonRow(row: unknown): row is NewButtonRow {
  return (
    !!row &&
    !isGraphqlButtonRow(row) &&
    typeof row === 'object' &&
    'header' in row &&
    'items' in row &&
    typeof row.header === 'string' &&
    Array.isArray(row.items)
  )
}

export function isDirtyButtonRow(row: unknown): row is DirtyButtonRow {
  return (
    !!row &&
    typeof row === 'object' &&
    'id' in row &&
    '__typename' in row &&
    row.__typename == 'ButtonRow' &&
    'isDirty' in row &&
    typeof row.isDirty === 'boolean' &&
    row.isDirty
  )
}

export function isGraphqlButtonRow(
  row: unknown
): row is GraphQL.ButtonRowFragmentFragment {
  return (
    !!row &&
    !isDirtyButtonRow(row) &&
    typeof row === 'object' &&
    'id' in row &&
    '__typename' in row &&
    row.__typename == 'ButtonRow'
  )
}

export function isButtonRow(row: unknown): row is ButtonRow {
  return isGraphqlButtonRow(row) || isNewButtonRow(row) || isDirtyButtonRow(row)
}
